import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/690a0c9f8dff8b0014626ac9/pneuma_fem_bible/src/app/digital-books-library/page.jsx");
